import React, {Component} from 'react';
import { colorOptions } from '../../../helpers/select'


class PartnerCard extends Component
{
    state = {
        changing: false,
        partner: this.props.partner,
        partners: this.props.partners
    };

    timeout = 2000;
    velocity = 1000;

    componentDidMount() {
        if (this.props.animation) setTimeout(() => this.toggleRefresh(), (this.props.key_as_prop + 6) * this.timeout);
    }

    toggleRefresh() {
        this.setState({ changing: true });
        setTimeout(() =>
            this.setState({ changing: false, partner: this.retrieveNewPartner()}, () => {
                setTimeout(() => this.toggleRefresh(), this.timeout * 6);
            }), this.velocity
        )
    }

    retrieveNewPartner() {

        const {partners} = this.state;
        let partners_length = partners.length - 1;
        let key_ = null;
        let elements = 6;

        partners.map((partner, key) => {
            if (partner.id === this.state.partner.id)
                key_ = key;
        });

        let position = elements - (partners_length - key_);

        if (key_ && position >= 0)
            return partners[position];
        else
            return partners[key_ + elements];
    }

    render() {
        const {key_as_prop} = this.props;
        const {partner} = this.state;
        const color = colorOptions[Math.floor(Math.random() * colorOptions.length)];

        return(
            <li
                className={(this.state.changing ? 'changing' : 'not-changing' + ' brand-' + color.value) + " brand" + (key_as_prop + 1)}
                key={key_as_prop}
                ref={this.card}
            >
                <img src={partner.attachment ? partner.attachment.url : ''} alt={partner.name} className='p-2'/>
            </li>
        )
    }
}

export default PartnerCard;
